// @flow

import moveEstimateOptional from '../../../Services/moveEstimateOptional';
import type { MoveEstimateOptionalParams } from '../../../types';

export default (params: MoveEstimateOptionalParams) => async (dispatch: Function) => dispatch(moveEstimateOptional(params))